<template>
  <master-layout
    v-slot="slotProps"
    :enable-scroll-event="true"
    @on-scroll="handleScroll"
    id="contentSchedule"
  >
    <!-- TODO Nav Bar -->
    <div
      class="shadow h-[52px] bg-white top-0px lg:top-0 fixed w-full lg:w-[calc(100%-292px)] lg:right-0"
      :class="{
        'z-[4]': showNavbar,
        hidden: !showNavbar,
        'pt-[44px] h-[96px]': isIos(),
      }"
    >
      <div class="flex justify-start items-center h-[52px] bg-white md:w-[648px] md:mx-auto">
        <DayDropdown :highlightDay="highlightDateStr" @onChange="choose" />
      </div>
    </div>
    <div class="lg:w-full">
      <div v-if="type" class="top-0 lg:pb-[24px] bg-white md:bg-grey-5 lg:mx-auto">
        <div class="fixed bottom-[88px] z-50">
          <CheatConsole v-if="isNonProd"></CheatConsole>
        </div>
        <!-- top banner section-->
        <div id="main-container " :class="isGenConf(isWeekday, 'mr-[15px] sm:mr-0')">
          <section
            v-show="!isWeekday"
            class="flex relative flex-col item-center h-[210px] bg-cover pt-[40px] md:pt-12 bg-gens-conf justify-center md:bg-none"
            :class="{ '!pt-[60px] !h-[250px]': isIos() }"
          >
            <img
              id="gens-conf-logo"
              src="../../../public/assets/images/gpc-2026-logo.png"
              class="block md:hidden z-1 w-[179px] mx-auto"
            />
            <img
              id="gens-conf-logo"
              src="../../../public/assets/images/gpc-2026-logo.png"
              class="hidden md:block z-1 w-[342px] mx-auto"
            />
            <a class="mx-auto mt-3 mb-2" :href="scheduleLink" target="_blank">
              <button
                id="schedule-gc"
                class="rounded-full w-auto text-white text-center px-3 py-2 bg-lightblue flex gap-x-1 hover:bg-[#303494]"
                data-event-tracking="gensapp-schedule-scheduleataglance"
                @click="logEvent()"
              >
                <img
                  src="../../../public/assets/icons/download-blue.svg"
                  class="w-[16px] h-[16px] self-center"
                />
                <div class="font-aktiv-grotesk-trial text-center">
                  {{ type === 'SCS' ? 5 : 2 }}-Day Schedule
                </div>
              </button>
            </a>
            <px
              class="font-aktiv-grotesk-trial mb-8 text-lightblue text-[12px] leading-[20px] text-center"
            >
              <!-- Also available in 繁体中文 and ไทย -->
            </px>
          </section>
          <section
            v-show="isWeekday"
            class="flex relative flex-col item-center h-[210px] bg-cover pt-[40px] md:pt-12 bg-gens-conf justify-center md:bg-none"
            :class="{ '!pt-[60px] !h-[250px]': isIos() }"
          >
            <img
              id="scs-logo"
              src="../../../public/assets/images/gpc-2026-logo.png"
              class="block md:hidden z-1 w-[179px] mx-auto"
            />
            <img
              id="scs-logo"
              src="../../../public/assets/images/gpc-2026-logo.png"
              class="hidden md:block z-1 w-[342px] mx-auto"
            />
            <in-app-browser
              id="schedule-scs"
              class="mx-auto mt-3 mb-2"
              :href="scheduleLink"
              target="_blank"
            >
              <button
                class="rounded-full w-auto text-white text-center px-3 py-2 bg-lightblue flex gap-x-1 hover:bg-[background: #00A9E0]"
                data-event-tracking="gensapp-schedule-scheduleataglance"
              >
                <img
                  src="../../../public/assets/icons/download-blue.svg"
                  class="w-[16px] h-[16px] self-center"
                />
                <div class="font-aktiv-grotesk-trial text-center">5-Day Schedule</div>
              </button>
            </in-app-browser>
            <p
              class="font-aktiv-grotesk-trial mb-8 text-white text-[12px] leading-[20px] md:text-lightblue text-center"
            >
              <!-- Also available in 繁体中文 and ไทย -->
            </p>
          </section>
        </div>
        <!-- Date selection section -->
        <section
          class="flex flex-col gap-6 bg-white relative z-1 pt-6 -mt-5 rounded-3xl lg:mb-24 md:mt-5 md:mx-auto md:w-[648px] lg:w-[648px]"
        >
          <div class="flex justify-center w-[320px] xs:w-[335px] mx-auto">
            <div id="conf-dates" class="flex justify-center w-[320px] xs:w-[335px] mx-auto">
              <div
                v-for="(card, date) in cards"
                :key="card.id"
                :card="card"
                :class="isGenConf(card.weekday, 'hidden')"
              >
                <div
                  :id="card.dayNum"
                  class="card relative rounded-[100px] mx-[3.5px] py-[11px] w-[50px] xs:w-[60px] border border-opacity-25 transition duration-100 ease-linear cursor-pointer"
                  :class="getDateCardClass(date, card.weekday)"
                  :data-test-id="card.dataTestId"
                  @click="choose(card)"
                >
                  <div class="text-center font-aktiv-grotesk-trial text-[20px] leading-[24px] pb-1">
                    {{ card.day }}
                  </div>
                  <div class="text-center font-aktiv-grotesk-trial text-[20px] leading-[24px]">
                    {{ card.dayNum }}
                  </div>
                  <div class="text-center font-aktiv-grotesk text-[16px] leading-[24px]">
                    {{ card.month }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="relative">
              <AnnouncementPanel
                :announcement-str="announcementStr"
                :schedule-callout="currentScheduleCallout"
              ></AnnouncementPanel>
            </div>
          </div>

          <div v-if="isLoadingEvents" class="flex justify-center py-10">
            <LoadingState />
          </div>
          <section v-else class="flex flex-col space-y-4 mb-6">
            <div v-for="(event, i) in eventsWithDate" :key="i">
              <EventsCard
                v-if="event.type !== 'invited'"
                :id="event.slug"
                :key="i"
                :event-type="event.type"
                :show-time="event.showTime"
                :label="event.label"
                :card-label="event.cardLabel"
                :title="event.title"
                :location="event.location"
                :notes="event.notes"
                :sessionId="event.sessionId ? event.sessionId.sessionId : 0"
                :livevoice="event?.enableLiveInterpretation"
                :livevoicelink="event?.liveInterpretationLink"
                :has-material="event.sessionId ? event.sessionId.totalMaterialsCount > 0 : false"
                :is-weekday="isWeekday"
                :start-time="event.startTime"
                :now="event.now"
                :table-time-questions="getTableTimeQuestion(event)"
                :has-seating="hasSeating(event)"
                :alumni="event.alumni"
                :toggle-alumni="toggleAlumni"
                :hide-delegate-type="event.hideDelegateType"
                :timing="event.timing"
                :cg-exp="event.cgExp"
                :sub-exp="false"
                :card-description="event.cardDescription"
                :cg-exps="event.cgExps"
                :interest-desc="event.interestDesc"
                :expFindOut="event.expFindOut"
                @show-popup="triggerExpPopup($event, slotProps)"
              />
              <MediaControlRoomCard
                v-else
                :timing="event.timing"
                :location="event.location"
                :id="event.id"
              ></MediaControlRoomCard>
            </div>
          </section>

          <section class="flex flex-col mx-auto font-aktiv-grotesk w-full px-6 gap-6 pt-6">
            <EodPanelCMS :schedule-callout="currentScheduleCallout"></EodPanelCMS>
            <div>
              <div
                class="flex flex-col cursor-pointer text-lightblue"
                data-event-tracking="gensapp-schedule-backtotop"
                @click="backToTop()"
              >
                <div class="flex flex-col flex-wrap justfiy-center mb-[24px]">
                  <img src="../../../public/assets/icons/chevron-up-purple.svg" />
                  <p
                    class="text-center text-[16px] leading-[24px] font-aktiv-grotesk-trial hover:underline"
                  >
                    Back to top
                  </p>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import moment from 'moment';
import momentts from 'moment-timezone';
import axios from 'axios';
import EventsCard from '../../components/SchedulePage/EventsCard';
import EodPanelCMS from '../../components/SchedulePage/EodPanelCMS.vue';
import AnnouncementPanel from '../../components/SchedulePage/AnnouncementPanel.vue';
import CheatConsole from '../../components/common/CheatConsole.vue';
import { useAuth0 } from '@auth0/auth0-vue';
import DayDropdown from '../../components/SchedulePage/DayDropdown.vue';
import store from '@/store/index';
import { isIosNativeOnly } from '@/utils/platform-check';
import { scheduleDaySlugs } from '@/utils/schedulePageSlugs';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
import { App as CapApp } from '@capacitor/app';
import MediaControlRoomCard from '../../components/SchedulePage/MediaControlRoomCard.vue';
import LoadingState from '../../components/common/LoadingState.vue';

export default {
  name: 'SchedulePage',
  components: {
    EventsCard,
    EodPanelCMS,
    AnnouncementPanel,
    CheatConsole,
    DayDropdown,
    MediaControlRoomCard,
    LoadingState,
  },
  data() {
    return {
      show: false,
      events: [],
      selectedDateStr: '',
      isLoadingEvents: false,
      latestEventsRequestId: 0,
      cacheEventsData: {},
      speStartTime: '2023-07-23T02:00:00.000Z',
      seatings: [],
      toggleAlumni: true,
      scheduleTourStep1Text: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Schedule</span> <br> <br>
            <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Access the full conference schedule.</span>`,
      scheduleTourStep2Text: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Schedule (Daily View)</span> <br> <br>
            <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">View the daily session timings and venues.</span>`,
      scheduleTourStep3Text: `<span style="text-align:left; color:#231F20; font-size: 20px; line-height: 24px;">Session Resources</span> <br> <br>
            <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 16px; line-height: 24px;">Check out “See session resources” and you’re ready for the session!</span>`,
      scheduleDaySlugs: scheduleDaySlugs,
      appStateListener: null,
    };
  },
  setup() {
    const { isAuthenticated, user } = useAuth0();

    const showNavbar = ref(false);
    let scrollThreshold = 200; // Default scroll threshold

    const handleScroll = async $event => {
      const scrollElement = await $event.target.getScrollElement();
      showNavbar.value = scrollElement.scrollTop >= scrollThreshold;
    };

    const updateScrollThreshold = () => {
      const screenWidth = window.innerWidth;

      // Adjust the scroll threshold based on screen size
      if (screenWidth < 768) {
        scrollThreshold = 366;
      } else if (screenWidth < 1024) {
        scrollThreshold = 316;
      } else {
        scrollThreshold = 316;
      }
    };

    const isIos = isIosNativeOnly;

    onMounted(() => {
      window.addEventListener('resize', updateScrollThreshold);
      updateScrollThreshold();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateScrollThreshold);
    });

    return {
      isAuthenticated,
      user,
      showNavbar,
      handleScroll,
      isIos,
    };
  },
  created() {
    this.$store.dispatch('signup/fetchDates');
  },
  computed: {
    ...mapGetters('profile', ['type']),
    ...mapGetters('schedule', ['linkOpenDate', 'scheduleDates']),
    ...mapState('signup', ['invitedMcrSignups']),
    ...mapState('timer', ['currDate']),
    ...mapState('user', ['token']),
    ...mapState('profile', ['hasCompletedScheduleTour']),
    ...mapState('livevoice', ['livevoiceSession']),
    ...mapState('schedule', ['scrollPosition', 'scheduleDates']),
    ...mapState('cms', ['scheduleCallout']),

    rotationClass() {
      return this.show ? 'rotate-180' : '';
    },
    scheduleLink() {
      return this.type === 'SCS'
        ? 'https://gens.app/full-schedule'
        : 'https://cdn.generationsmvmt.com/docs/GenSConf-Translated-Schedule-July-2023-Weekend.pdf';
    },
    eventsWithDate() {
      const timingArray = [];
      const computedEvent = [];
      this.events.forEach(event => {
        let showTime = true;
        if (timingArray.includes(event.startTime)) {
          showTime = false;
        }
        timingArray.push(event.startTime);
        event.showTime = showTime;
        computedEvent.push(event);
        if (event.id in this.invitedMcrSignups) {
          const signup = this.invitedMcrSignups[event.id];
          computedEvent.push({
            id: 'mcr-' + event.id,
            type: 'invited',
            timing: signup.expTime,
            location: [signup.location],
          });
        }
      });

      return computedEvent;
    },
    highlightDateStr() {
      if (this.selectedDateStr !== '') return this.selectedDateStr;

      momentts.tz.setDefault('Asia/Singapore');
      let displayStr =
        this.currDate === ''
          ? momentts().format('YYYY-MM-DD')
          : momentts(this.currDate).format('YYYY-MM-DD');
      const dateFirstStr = this.scheduleDates[0];
      const dateLastStr = this.scheduleDates[this.scheduleDates.length - 1];
      const dateFirstStrGC = this.checkWeekend(this.scheduleDates).Sat;
      const dateLastStrGC = this.checkWeekend(this.scheduleDates).Sun;

      const display = new Date(displayStr);
      const dateFirst = new Date(dateFirstStr);
      const dateLast = new Date(dateLastStr);
      const dateFirstGC = new Date(dateFirstStrGC);
      const dateLastGC = new Date(dateLastStrGC);

      if (display.getTime() < dateFirst.getTime()) displayStr = dateFirstStr;
      if (display.getTime() > dateLast.getTime()) displayStr = dateLastStr;
      if (display.getTime() < dateFirstGC.getTime() && this.type === 'GC')
        displayStr = dateFirstStrGC;
      if (display.getTime() > dateLastGC.getTime() && this.type === 'GC')
        displayStr = dateLastStrGC;
      return displayStr;
    },
    isWeekday() {
      return this.cards[this.highlightDateStr].weekday;
    },
    isSunday() {
      return this.cards[this.highlightDateStr].day === 'Sun';
    },
    day() {
      const dayHighlighted = this.cards[this.highlightDateStr].id;
      return this.type === 'GC' ? dayHighlighted - 2 : dayHighlighted;
    },
    currentScheduleCallout() {
      return this.scheduleCallout.find(c => c.day === this.day) || null;
    },
    announcementStr() {
      return this.cards[this.highlightDateStr].announcement[this.type];
    },
    seatingMap() {
      if (!this.seatings) return {};
      const map = {};
      this.seatings.forEach(seating => {
        map[seating.serviceId] = seating.allocation !== '';
      });
      return map;
    },
    isNonProd() {
      return process.env.VUE_APP_NODE_ENV !== 'production';
    },
    isPastLastDay() {
      const currentDate = this.currDate === '' ? new Date() : new Date(this.currDate);

      const lastDayStr =
        this.type === 'SCS'
          ? this.scheduleDates[this.scheduleDates.length - 1]
          : this.scheduleDates[this.scheduleDates.length - 2];
      const lastDay = new Date(lastDayStr);

      return currentDate.getTime() > lastDay.getTime();
    },
    isScheduleAnchorTagPresentInTheUrl() {
      if (this.$route.hash) {
        // slice(0, 5) to get the first 5 digits to determine which day
        return this.scheduleDaySlugs.includes(this.$route.hash.slice(1, 6));
      }
      return false;
    },
    cards() {
      const schedules = {};

      // Dynamic based on schedule dates in store
      this.scheduleDates.forEach((dateStr, idx) => {
        const date = moment(dateStr);
        const day = date.day();
        const isWeekday = day !== 0 && day !== 6;
        const announcement = {};

        // if (idx === 0) {
        //   announcement.SCS = `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">Hello / G’day / Güten tag ~</div>
        //      📣 Have lunch before coming & grab a jacket!<br>`;
        // } else if (idx === 1) {
        //   announcement.SCS = `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">Wasn't last night 🤯 ?<br>Here's Day 2!</div>
        //      📣 Grab a bite before coming!<br>`;
        // } else if (idx === 2) {
        //   announcement.SCS = `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">It’s the weekend!</div>
        //      📣 See you after you’ve had your lunch! 🍔<br>`;
        //   announcement.GC = `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">It’s the weekend!</div>
        //      📣 See you after you’ve had your lunch! 🍔<br>`;
        // } else if (idx === 3) {
        //   announcement.SCS =
        //     '<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">Sunday is church day!</div>📣 See you after you’ve had your lunch! 🍔';
        //   announcement.GC =
        //     '<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">Sunday is church day!</div>📣 See you after you’ve had your lunch! 🍔';
        // } else {
        //   announcement.SCS = `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">We've saved the best for last – don't miss it!</div>📣 Grab a bite before coming!<br>`;
        // }

        schedules[dateStr] = {
          id: idx + 1,
          day: date.format('ddd'),
          dayNum: date.format('DD'),
          month: date.format('MMM'),
          date: dateStr,
          dataTestId: `gensapp-schedule-button-${date.format('MMM').toLowerCase()}-${date.format(
            'DD',
          )}`,
          weekday: isWeekday,
          announcement,
        };
      });

      return schedules;
    },
  },
  async ionViewWillEnter() {
    await this.refreshScheduleData();
  },
  updated() {
    if (this.linkOpenDate !== '') {
      // consume-once: clear before choosing so re-renders don't re-trigger choose()
      const card = this.cards[this.linkOpenDate];
      this.setLinkOpenDate('');
      if (card) this.choose(card);
    }

    if (this.scrollPosition !== 0) {
      const elem = document.getElementById('contentSchedule');
      const scrollTarget = this.scrollPosition <= 1 ? 0 : this.scrollPosition;
      elem.scrollToPoint(0, scrollTarget, 1000);
      this.setScrollPosition(0);
    }
  },
  async ionViewDidEnter() {
    if (this.appStateListener) {
      await this.appStateListener.remove();
      this.appStateListener = null;
    }
    this.appStateListener = await CapApp.addListener('appStateChange', async ({ isActive }) => {
      if (isActive) {
        await this.refreshScheduleData();
      }
    });

    await this.$store.dispatch('signup/fetchSignup');
    setTimeout(() => {
      if (!this.hasCompletedScheduleTour) {
        if (this.type === 'SCS') {
          this.loadSCSTour();
        }
      }
    }, 100);
    if (this.isScheduleAnchorTagPresentInTheUrl) {
      const hash = this.$route.hash;
      await this.chooseDateBasedOn(hash);
      this.scrollToEventBasedOn(hash);
    }
    FirebaseAnalytics.setScreenName({
      screenName: 'schedule',
      nameOverride: 'SchedulePage',
    });
  },
  async ionViewDidLeave() {
    if (this.appStateListener) {
      await this.appStateListener.remove();
      this.appStateListener = null;
    }
  },
  methods: {
    ...mapActions('schedule', ['setLinkOpenDate', 'setScrollPosition']),
    ...mapState('tour', ['setTour']),

    async refreshScheduleData() {
      await Promise.all([
        this.$store.dispatch('profile/forceFetchProfile'),
        this.$store.dispatch('cms/fetchScheduleCallout'),
        this.$store.dispatch('cms/fetchAnnouncements', {
          locale: 'en',
          conferenceType: 'Global',
          force: true,
        }),
        this.$store.dispatch('announcements/fetchUnreadCount', 'Global'),
        this.$store.dispatch('signup/fetchExpData', {
          locale: 'en',
          conferenceType: 'Global',
        }),
        this.$store.dispatch('signup/fetchMainExpData', {
          locale: 'en',
          conferenceType: 'Global',
        }),
      ]);

      const card = this.cards[this.highlightDateStr];
      await this.setEventData(card);
    },

    getDateCardClass(date, weekday) {
      let bgColorCode = '';
      let bgColorHoverCode = '';
      let textColorCode = '';
      let borderColorCode = '';
      let classname = '';

      if (weekday) {
        bgColorCode = 'bg-lightblue';
        bgColorHoverCode = 'hover:bg-lightblue';
        textColorCode = 'text-lightblue hover:text-white';
        borderColorCode = 'border-lightblue';
      } else {
        bgColorCode = 'bg-lightblue';
        bgColorHoverCode = 'hover:bg-lightblue';
        textColorCode = 'text-lightblue hover:text-white';
        borderColorCode = 'border-lightblue';
      }
      const cardDate = new Date(date);
      const highlightDate = new Date(this.highlightDateStr);

      // auto date card background
      if (cardDate.getTime() === highlightDate.getTime()) {
        const textWhiteColorCode = 'text-white pointer-events-none';
        classname += ' ' + textWhiteColorCode + ' ' + bgColorCode + ' ' + borderColorCode + ' ';
      } else classname += ' ' + textColorCode + ' ' + borderColorCode + ' ' + bgColorHoverCode;

      if (this.type === 'GC' && weekday) {
        classname += ' hidden ';
      }

      return classname;
    },
    checkWeekend(dateList) {
      let Sat,
        Sun = '';
      dateList.forEach(date => {
        if (moment(date).day() === 6) {
          Sat = date;
        } else if (moment(date).day() === 0) {
          Sun = date;
        }
      });
      return { Sat, Sun };
    },
    expandCard() {
      this.show = !this.show;
    },
    logEvent() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'gensapp-schedule-scheduleataglance',
          page: 'schedule',
        },
      });
    },
    isGenConf(weekday, classText) {
      let className = '';
      if (this.type === 'GC' && weekday) {
        className += classText;
      }
      return className;
    },
    async setEventData(card) {
      // cache data in memory
      // if (card.date in this.cacheEventsData) {
      //   const cacheData = this.cacheEventsData[card.date];
      //   const currentTs = new Date().getTime();
      //   const timeElapsed = currentTs - cacheData.lastFetched;
      //   const threeMin = 3 * 60 * 1000;
      //   if (timeElapsed < threeMin) {
      //     this.events = cacheData.data;
      //     return;
      //   }
      // }
      // stale responses must not overwrite the most recently selected day
      const requestId = ++this.latestEventsRequestId;
      this.isLoadingEvents = true;
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_URL + '/cms/schedules/' + card.date,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          },
        );
        if (requestId !== this.latestEventsRequestId) return;
        this.cacheEventsData[card.date] = {
          data: result.data,
          lastFetched: new Date().getTime(),
        };
        this.events = result.data;
      } finally {
        if (requestId === this.latestEventsRequestId) {
          this.isLoadingEvents = false;
        }
      }
    },
    backToTop() {
      const elem = document.getElementById('contentSchedule');
      elem.scrollToTop(1000);
    },
    async choose(card) {
      if (card.date === this.highlightDateStr) return;
      this.backToTop();
      // to-do {need a auto scroll to top function after user selects the date}
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'gensapp-schedule-day-' + card.id + '-select',
          page: 'schedule',
        },
      });
      this.selectedDateStr = card.date;
      await this.setEventData(card);
    },
    hasSeating(event) {
      const serviceId = this.getServiceId(event);
      if (serviceId === null) return false;

      return serviceId in this.seatingMap && this.seatingMap[serviceId];
    },
    getServiceId(event) {
      if (!event.title || !event.label) return null;
      // no the best way to handle, should use type instead of string manipulation since copy can change
      if (event.title.includes("Leaders' Meeting")) return 0;
      if (event.title.includes('Dreams & Stories')) return 999;
      if (event.label.includes('SERVICE')) {
        const labelList = event.label.split(' ');
        return labelList[1];
      }
      return null;
    },
    async skipScheduleTour() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'guided-tour-skip-schedule',
          page: 'schedule',
        },
      });
      const payload = {
        hasCompletedScheduleTour: true,
        conferenceType: 'Global',
      };
      await this.$store.dispatch('profile/setScheduleTourStatus', payload);
      store.dispatch('tour/setTour', null);
      this.backToTop();
      this.tour.cancel();
    },
    async endScheduleTour() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'guided-tour-end-schedule',
          page: 'schedule',
        },
      });
      const payload = {
        hasCompletedScheduleTour: true,
        conferenceType: 'Global',
      };
      await this.$store.dispatch('profile/setScheduleTourStatus', payload);
      store.dispatch('tour/setTour', null);
      this.backToTop();
      this.tour.cancel();
    },
    startScheduleTour() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'guided-tour-start-schedule',
          page: 'schedule',
        },
      });
      this.tour.next();
    },
    loadSCSTour() {
      this.tour = this.$shepherd({
        useModalOverlay: true,
        defaultStepOptions: {
          classes: 'bg-yellow',
          cancelIcon: {
            enabled: true,
          },
          when: {
            show() {
              const currentStep = this.tour.getCurrentStep();
              const currentStepElement = currentStep?.getElement();
              const header = currentStepElement?.querySelector('.shepherd-header');
              const progress = document.createElement('span');
              progress.style['border-radius'] = '100px';
              progress.style['background'] = '#FFD900';
              progress.style['font-size'] = '12px';
              progress.style['font-weight'] = '500';
              progress.style['line-height'] = '20px';
              progress.style['color'] = '#2B2E79';
              progress.style['font-family'] = 'Arial';
              progress.style['width'] = '77px';
              progress.style['text-align'] = 'center';
              progress.className = 'shepherd-progress';
              progress.innerText = `Step ${this.tour.steps.indexOf(currentStep) + 1} of ${
                this.tour.steps.length
              }`;
              header?.insertBefore(
                progress,
                currentStepElement?.querySelector('.shepherd-cancel-icon'),
              );
            },
            cancel() {
              const payload = {
                hasCompletedScheduleTour: true,
                conferenceType: 'Global',
              };
              store.dispatch('profile/setScheduleTourStatus', payload);
              store.dispatch('tour/setTour', null);
            },
          },
          keyboardNavigation: false,
        },
      });
      const steps = [
        {
          id: 'schedule-scs',
          attachTo: {
            element: '#schedule-scs',
            on: 'bottom',
          },
          buttons: [
            {
              text: 'Skip',
              action: this.skipScheduleTour,
              secondary: true,
            },
            {
              text: 'Next',
              action: this.startScheduleTour,
            },
          ],
          highlightClass: 'highlight',
          text: this.scheduleTourStep1Text,
          scrollTo: { behavior: 'smooth', block: 'center' },
          canClickTarget: false,
        },
        {
          id: 'dates-scs',
          attachTo: {
            element: '#conf-dates',
            on: 'bottom',
          },
          buttons: [
            {
              text: 'Back',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'Next',
              action: this.tour.next,
            },
          ],
          highlightClass: 'highlight',
          text: this.scheduleTourStep2Text,
          scrollTo: { behavior: 'smooth', block: 'center' },
          canClickTarget: false,
        },
        {
          id: 'materials-scs',
          attachTo: {
            element: '#contentSchedule .materials-card',
            on: 'bottom',
          },
          text: this.scheduleTourStep3Text,
          buttons: [
            {
              text: 'Back',
              action: this.tour.back,
              secondary: true,
            },
            {
              text: 'End',
              action: this.endScheduleTour,
            },
          ],
          scrollTo: { behavior: 'smooth', block: 'center' },
          canClickTarget: false,
        },
      ];

      this.tour.addSteps(steps);
      this.tour.start();
      this.choose(this.cards[this.scheduleDates[0]]);
      this.setTour(this.tour);
    },

    getTableTimeQuestion(event) {
      if (!event.hasTableTimeQuestion) return '';

      const defaultHtml = `
        <p class="text-[14px] font-aktiv-grotesk-medium text-grey-80">*Includes Discussion Time</p>
        <div class="text-[14px] text-grey-60">
          Set actionable steps with your team
        </div>
      `;

      if (!event.sessionId) return defaultHtml;
      if (!event.sessionId.questions.length) return defaultHtml;
      return (
        '<p class="text-[14px] font-aktiv-grotesk-medium text-grey-80">Discussion Time</p>' +
        event.sessionId.questions[0].description
      );
    },
    triggerExpPopup(exp, slotProps) {
      console.log('in triggerExpPopup');
      slotProps.toggleExp(exp, false);
    },
    async chooseDateBasedOn(hash) {
      // slice(5, 6) to get the digit of which day it is, e.g. 1 for day 1
      const dayIndex = parseInt(hash.slice(5, 6), 10);
      const date = this.scheduleDates[dayIndex - 1];
      await this.choose(this.cards[date]);
    },
    scrollToEventBasedOn(hash) {
      // substring(1) to remove the # in the hash
      const eventToScrollTo = document.getElementById(hash.substring(1));
      if (eventToScrollTo) {
        eventToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>
<style scoped>
.shadow {
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
}
</style>
